var render = function (_h,_vm) {var _c=_vm._c;return _c('span',{staticClass:"icon"},[_c('i',{staticClass:"mdi",class:[_vm.props.size, _vm.props.icon],style:({color: _vm.props.color}),attrs:{"aria-hidden":"true"}})])}
var staticRenderFns = []

export { render, staticRenderFns }